import React from "react";

const FilterQuestion = ({
  topics,
  setTopic,
  topic,
  setSubject,
  subject,
  setMarks,
  marks,
  setLevel,
  level,
}) => {
  return (
    <div className="flex sm:flex-row flex-col sm:items-center gap-2">
      {/* By topic */}
      <select
        className="h-[32px] text-sm border px-3 rounded-[4px] border-textSecondary focus:outline-none text-textSecondary w-full"
        value={topic}
        onChange={(e) => {
          setTopic(e.target.value);
          setSubject("");
        }}
      >
        <option value="" className="text-textSecondary">
          By topic
        </option>
        {topics?.map((entry) => (
          <option
            key={entry._id}
            value={entry._id}
            className="text-textSecondary"
          >
            {entry.topicName}
          </option>
        ))}
      </select>

      {/* By subject */}
      <select
        value={subject}
        className="h-[32px] text-sm border px-3 rounded-[4px] border-textSecondary focus:outline-none text-textSecondary w-full"
        onChange={(e) => {
          setSubject(e.target.value);
        }}
      >
        <option value="" className="text-textSecondary">
          By subject
        </option>
        {topics?.map((_topic) =>
          _topic._id === topic
            ? _topic.subjectDetails.map((entry) => (
                <option
                  key={entry._id}
                  value={entry._id}
                  className="text-textSecondary"
                >
                  {entry.subjectName}
                </option>
              ))
            : null
        )}
      </select>

      {/* By marks */}
      <select
        value={marks}
        className="h-[32px] text-sm border px-3 rounded-[4px] border-textSecondary focus:outline-none text-textSecondary w-full"
        onChange={(e) => {
          setMarks(e.target.value);
        }}
      >
        <option value="" className="text-textSecondary">
          By Marks
        </option>
        <option value="1" className="text-textSecondary">
          1
        </option>
        <option value="2" className="text-textSecondary">
          2
        </option>
      </select>

      {/* By level */}
      <select
        value={level}
        className="h-[32px] text-sm border px-3 rounded-[4px] border-textSecondary focus:outline-none text-textSecondary w-full"
        onChange={(e) => {
          setLevel(e.target.value);
        }}
      >
        <option value="" className="text-textSecondary">
          By Level
        </option>
        <option value="easy" className="text-textSecondary">
          Easy
        </option>
        <option value="medium" className="text-textSecondary">
          Medium
        </option>
        <option value="hard" className="text-textSecondary">
          Hard
        </option>
      </select>
    </div>
  );
};

export default FilterQuestion;
